export default __webpack_public_path__ + "static/media/pdf.05847660.svg";